import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from '../shared';

const ConfirmMoveDialog = ({ isOpen, pendingMove, onConfirm, onCancel, columns }) => {
  if (!pendingMove) return null;

  const fromColumn = columns.find(c => c.id === pendingMove.fromStatus);
  const toColumn = columns.find(c => c.id === pendingMove.toStatus);

  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      title="Confirm Move"
      subtitle="Are you sure you want to move this need?"
      icon={AlertTriangle}
      maxWidth="max-w-lg"
      headerGradient="from-yellow-50 to-orange-50"
    >
      <div className="p-6">
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-900 font-medium mb-2">"{pendingMove.needTitle}"</p>
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <span>From: <span className="font-medium">{fromColumn?.title}</span></span>
            <span>→</span>
            <span>To: <span className="font-medium">{toColumn?.title}</span></span>
          </div>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Confirm Move
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmMoveDialog; 